import { Logo } from "./Logo";
import { whatsappLink, CONTACT } from "../data/content";

export const Footer = ({ onNavigate }) => (
  <footer
    data-testid="site-footer"
    className="relative border-t border-[#282338] bg-[#060509] pt-16 pb-8 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-[#A19CAE] max-w-xs leading-relaxed">
            Agenzia di spettacolo e produzioni. Canto, musica, ballo, moda e
            show — dal palco al set.
          </p>
        </div>
        <div className="flex gap-16">
          <div>
            <p className="font-mono-label text-[10px] tracking-[0.3em] text-[#E6C594] mb-4">
              NAVIGAZIONE
            </p>
            <ul className="space-y-2.5 text-sm text-[#A19CAE]">
              {[
                ["#artisti", "Artisti & Spettacoli"],
                ["#produzioni", "Produzioni"],
                ["#agenzia", "L'Agenzia"],
                ["#contatti", "Contatti"],
              ].map(([href, label]) => (
                <li key={href}>
                  <button
                    data-testid={`footer-link-${href.slice(1)}`}
                    onClick={() => onNavigate(href)}
                    className="hover:text-[#E6C594] transition-colors duration-300"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono-label text-[10px] tracking-[0.3em] text-[#E6C594] mb-4">
              CONTATTI
            </p>
            <ul className="space-y-2.5 text-sm text-[#A19CAE]">
              <li>
                <a
                  data-testid="footer-whatsapp-link"
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#E6C594] transition-colors duration-300"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-phone-link"
                  href={CONTACT.phoneHref}
                  className="hover:text-[#E6C594] transition-colors duration-300"
                >
                  {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${CONTACT.email}`}
                  className="hover:text-[#E6C594] transition-colors duration-300"
                >
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <p
        aria-hidden="true"
        className="font-serif-display font-extrabold text-[13vw] leading-none text-center mt-16 select-none text-transparent"
        style={{ WebkitTextStroke: "1px #282338" }}
      >
        5.0
      </p>

      <div className="mt-10 pt-6 border-t border-[#282338] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#A19CAE]/70">
        <p>© 2026 Musica &amp; Moda 5.0 — Tutti i diritti riservati</p>
        <p className="font-mono-label tracking-[0.25em]">SHOW MUST GO ON</p>
      </div>
    </div>
  </footer>
);
